import { useReveal } from '@ccg/core';
import React$1 from 'react';
import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes$1 from 'prop-types';
import StyledText from './Text.style.js';

const Text = (_ref) => {
  let {
    content,
    hasGrid,
    hasOuterMargins,
    className,
    reveal
  } = _ref,
      props = _objectWithoutProperties(_ref, ["content", "hasGrid", "hasOuterMargins", "className", "reveal"]);

  if (!content) return null;

  if (reveal) {
    const [ref, isVisible] = useReveal();
    return /*#__PURE__*/React$1.createElement(StyledText, _extends({
      content: content,
      className: className,
      hasGrid: hasGrid,
      hasOuterMargins: hasOuterMargins,
      reveal: reveal,
      isVisible: isVisible,
      ref: ref
    }, props));
  }

  return /*#__PURE__*/React$1.createElement(StyledText, _extends({
    content: content,
    className: className,
    hasGrid: hasGrid,
    hasOuterMargins: hasOuterMargins
  }, props));
};

Text.propTypes = {
  className: PropTypes$1.string,
  content: PropTypes$1.string,
  hasGrid: PropTypes$1.bool,
  hasOuterMargins: PropTypes$1.bool,
  reveal: PropTypes$1.bool
};
Text.defaultProps = {
  className: '',
  content: '',
  hasGrid: false,
  hasOuterMargins: false,
  reveal: false
};

export default Text;
